import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import {
  features,
  dateStyle,
  language
} from '../config';
import Firebase from '../api/Firebase';

export default function Users() {
  const { api } = Firebase;
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists
  } = api;
  const [data, setData] = useState([]);
  const usersdata = useSelector(state => state.usersdata);
  const dispatch = useDispatch();

  useEffect(() => {
    if (usersdata.users) {
      setData(usersdata.users.filter(user => user.usertype === 'rider'));
    } else {
      setData([]);
    }
  }, [usersdata.users]);

  const columns = [
    { title: language.createdAt, field: 'createdAt', editable: 'never', defaultSort: 'desc', render: rowData => rowData.createdAt ? new Date(rowData.createdAt).toLocaleString(dateStyle) : null },
    { title: language.first_name, field: 'firstName' },
    { title: language.last_name, field: 'lastName' },
    { title: language.email, field: 'email', editable: 'onAdd' },
    { title: language.mobile, field: 'mobile', editable: 'onAdd' },
    // { title: language.profile_image, field: 'profileImage', render: rowData => rowData.profileImage ? <img alt='Profile' src={rowData.profileImage} style={{ width: 50, borderRadius: '50%' }} /> : null, editable: 'never' },
    { title: language.account_approve, field: 'approved', type: 'boolean' },
    { title: language.wallet_balance, field: 'walletBalance', type: 'numeric', editable: 'never', initialEditValue: 0 },
    { title: language.signup_via_referral, field: 'signupViaReferral', editable: 'never' },
    { title: language.referralId, field: 'referralId', editable: 'never', initialEditValue: '' },
  ];

  return (
    usersdata.loading ? <CircularLoading /> :
      <MaterialTable
        title={language.riders}
        columns={columns}
        data={data}
        options={{
          exportButton: true,
          sorting: true,
          pageSize: 10
        }}
        editable={{
          onRowAdd: newData =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                checkUserExists(newData).then((res) => {
                  if (res.success) {
                    if (res.data) {
                      alert(language.user_exists);
                      reject();
                    } else {
                      const formData = new FormData();
                      for (let key in newData) {
                        if (key != "mobile") {
                          formData.append(key, newData[key]);
                        }
                      }
                      formData.append('createdByAdmin', true);
                      formData.append('usertype', 'rider');
                      formData.append('mobile', "+91" + newData['mobile']);
                      dispatch(addUser(formData));
                      resolve();
                    }
                  }
                });
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise(resolve => {
              const formData = new FormData();
              for (let key in newData) {
                formData.append(key, newData[key]);
              }
              setTimeout(() => {
                resolve();
                dispatch(editUser(oldData.id, formData));
              }, 600);
            }),
          onRowDelete: oldData =>
            features.AllowCriticalEditsAdmin ?
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  dispatch(deleteUser(oldData.id));
                }, 600);
              })
              :
              new Promise(resolve => {
                setTimeout(() => {
                  resolve();
                  alert(language.demo_mode);
                }, 600);
              })
          ,
        }}
      />
  );
}
